/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Signup_Plan_Step_HintInputs */

const cs_auth_signup_plan_step_hint = /** @type {(inputs: Auth_Signup_Plan_Step_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vyberte tarif pro 30denní zkušební verzi. Později ho můžete změnit.`)
};

const en_auth_signup_plan_step_hint = /** @type {(inputs: Auth_Signup_Plan_Step_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose a plan for your 30-day trial. You can change it later.`)
};

/**
* | output |
* | --- |
* | "Choose a plan for your 30-day trial. You can change it later." |
*
* @param {Auth_Signup_Plan_Step_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_signup_plan_step_hint = /** @type {((inputs?: Auth_Signup_Plan_Step_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Signup_Plan_Step_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_signup_plan_step_hint(inputs)
	return cs_auth_signup_plan_step_hint(inputs)
});